import ControlledCheckbox from './ControlledCheckbox';

export default ControlledCheckbox;
